export { default } from "./ComparisonDetail";
